import { IParametre } from '../../../../service/fikoyt-ui/interfaces/IParametre/IParametre';

/**
 * HMI-Pano Parametre Setleri
 *
 * Tüm HMI konfigürasyonu parametre sistemiyle yönetilir.
 * Her set, ayarlar sayfasında bir sekme (tab) olarak gösterilir.
 * Değerler localStorage'a yazılır, uzak komutlarla güncellenebilir.
 */

// ═══════════════════════════════════════════════════════════════════════════════
// 1. CİHAZ KİMLİK AYARLARI
// ═══════════════════════════════════════════════════════════════════════════════

export const CIHAZ_KIMLIK_PARAMETRELERI: IParametre[] = [
  {
    turu: 'Simgeli Başlık', ismi: '_baslik_cihaz', baslik: '🔧 Cihaz Kimlik Bilgileri',
    degeri: null, ayarlar: {}, kontroller: [], hatalar: [], uyarilar: [],
  },
  {
    turu: 'Yazı', ismi: 'cihazIsmi', baslik: 'Cihaz İsmi', degeri: null,
    yerTutucu: 'Ör: HMI Ekran #1 - Üretim Katı',
    altAciklama: 'Bu isim admin panelinde ve telemetri verilerinde görünür',
    ayarlar: { zorunlu: true, solSimge: 'desktop' },
    kontroller: [{ fn: '(form, itm) => itm.degeri?.length >= 3', mesaj: 'En az 3 karakter gerekli' }],
    hatalar: [], uyarilar: [],
  },
  {
    turu: 'Yazı', ismi: 'cihazKimlik', baslik: 'Cihaz Kimliği (UUID)', degeri: null,
    yerTutucu: 'Otomatik oluşturulur',
    altAciklama: 'Benzersiz cihaz kimliği — değiştirilmemesi önerilir',
    ayarlar: { sadeceOkunur: true, solSimge: 'key' },
    kontroller: [], hatalar: [], uyarilar: [],
  },
  {
    turu: 'Açılır Kutu', ismi: 'cihazTipi', baslik: 'Cihaz Tipi', degeri: 'hmi_pano',
    ayarlar: {
      secenekler: [
        { etiket: 'HMI Bilgi Paneli', deger: 'hmi_pano' },
        { etiket: 'Kiosk Terminali', deger: 'kiosk' },
        { etiket: 'Geçiş Kontrol', deger: 'gecis_kontrol' },
        { etiket: 'Yemekhane Terminali', deger: 'yemekhane' },
        { etiket: 'Depo Terminali', deger: 'depo' },
        { etiket: 'Ziyaretçi Kaydı', deger: 'ziyaretci' },
      ],
    },
    kontroller: [], hatalar: [], uyarilar: [],
  },
  {
    turu: 'Yazı', ismi: 'firmaId', baslik: 'Bağlı Firma Kimliği', degeri: null,
    yerTutucu: 'Firma ID (admin panelden kopyalanır)',
    altAciklama: 'Bu HMI cihazın bağlı olduğu firma — kart sorgulama ve PDKS bu firmaya göre çalışır',
    ayarlar: { zorunlu: true, solSimge: 'bank' },
    kontroller: [], hatalar: [], uyarilar: [],
  },
  {
    turu: 'Yazı', ismi: 'konum', baslik: 'Fiziksel Konum', degeri: null,
    yerTutucu: 'Ör: A Blok - 2. Kat - Üretim Hattı',
    ayarlar: { solSimge: 'environment' },
    kontroller: [], hatalar: [], uyarilar: [],
  },
];

// ═══════════════════════════════════════════════════════════════════════════════
// 2. SUNUCU & BAĞLANTI AYARLARI
// ═══════════════════════════════════════════════════════════════════════════════

export const BAGLANTI_PARAMETRELERI: IParametre[] = [
  {
    turu: 'Simgeli Başlık', ismi: '_baslik_baglanti', baslik: '🌐 Sunucu & Bağlantı',
    degeri: null, ayarlar: {}, kontroller: [], hatalar: [], uyarilar: [],
  },
  {
    turu: 'Yazı', ismi: 'sunucuAdresi', baslik: 'Sunucu Adresi', degeri: null,
    yerTutucu: 'https://fikoyt.com:9000',
    altAciklama: 'FikoYT sunucu adresi (Socket.IO bağlantısı için)',
    ayarlar: { zorunlu: true, solSimge: 'global' },
    kontroller: [{ fn: '(form, itm) => /^https?:\\/\\/.+/.test(itm.degeri || "")', mesaj: 'Geçerli bir URL girin (http:// veya https://)' }],
    hatalar: [], uyarilar: [],
  },
  {
    turu: 'Sayı', ismi: 'telemetriAraligi', baslik: 'Telemetri Gönderim Aralığı (sn)', degeri: 30,
    altAciklama: 'Cihaz durum bilgilerinin sunucuya gönderilme sıklığı',
    ayarlar: { min: 5, maks: 300, adim: 5 },
    kontroller: [], hatalar: [], uyarilar: [],
  },
  {
    turu: 'Anahtar', ismi: 'otomatikBaglan', baslik: 'Otomatik Bağlan', degeri: true,
    altAciklama: 'Sayfa açıldığında otomatik olarak sunucuya bağlan',
    ayarlar: {}, kontroller: [], hatalar: [], uyarilar: [],
  },
  {
    turu: 'Anahtar', ismi: 'yenidenBaglanma', baslik: 'Otomatik Yeniden Bağlanma', degeri: true,
    altAciklama: 'Bağlantı kesilirse otomatik olarak yeniden bağlan',
    ayarlar: {}, kontroller: [], hatalar: [], uyarilar: [],
  },
  {
    turu: 'Sayı', ismi: 'yenidenBaglanmaSuresi', baslik: 'Yeniden Bağlanma Aralığı (sn)', degeri: 5,
    altAciklama: 'Bağlantı koptuğunda kaç saniye bekleyip tekrar denesin',
    ayarlar: { min: 1, maks: 60, adim: 1 },
    kontroller: [], hatalar: [], uyarilar: [],
  },
];

// ═══════════════════════════════════════════════════════════════════════════════
// 3. KART OKUYUCU AYARLARI
// ═══════════════════════════════════════════════════════════════════════════════

export const KART_OKUYUCU_PARAMETRELERI: IParametre[] = [
  {
    turu: 'Simgeli Başlık', ismi: '_baslik_kart', baslik: '💳 Kart Okuyucu',
    degeri: null, ayarlar: {}, kontroller: [], hatalar: [], uyarilar: [],
  },
  {
    turu: 'Açılır Kutu', ismi: 'kartBaglantiModu', baslik: 'Bağlantı Modu', degeri: 'websocket',
    altAciklama: 'Kart okuyucunun HMI panele nasıl bağlandığı',
    ayarlar: {
      secenekler: [
        { etiket: '🔌 Seri Port (USB)', deger: 'seri' },
        { etiket: '📡 WebSocket (Ağ)', deger: 'websocket' },
      ],
    },
    kontroller: [], hatalar: [], uyarilar: [],
  },
  {
    turu: 'Açılır Kutu', ismi: 'baudRate', baslik: 'Seri Port Hızı (Baud Rate)', degeri: 9600,
    altAciklama: 'Seri port bağlantı modu için — RFID okuyucuyla eşleşmeli',
    ayarlar: {
      secenekler: [
        { etiket: '9600', deger: 9600 },
        { etiket: '19200', deger: 19200 },
        { etiket: '38400', deger: 38400 },
        { etiket: '57600', deger: 57600 },
        { etiket: '115200', deger: 115200 },
      ],
    },
    kontroller: [], hatalar: [], uyarilar: [],
  },
  {
    turu: 'Yazı', ismi: 'kartOkuyucuCihazKimlik', baslik: 'Uzak Kart Okuyucu Kimliği', degeri: null,
    yerTutucu: 'Ör: FikoYT-Kart-Okuyucu-1',
    altAciklama: 'WebSocket modu için — dinlenecek uzak RFID cihazın kimliği',
    ayarlar: { solSimge: 'credit-card' },
    kontroller: [], hatalar: [], uyarilar: [],
  },
  {
    turu: 'Sayı', ismi: 'kartDebounceMs', baslik: 'Kart Debounce Süresi (ms)', degeri: 2000,
    altAciklama: 'Aynı kart art arda okunduğunda yok sayma süresi',
    ayarlar: { min: 500, maks: 10000, adim: 100 },
    kontroller: [], hatalar: [], uyarilar: [],
  },
  {
    turu: 'Anahtar', ismi: 'sesliGeriBildirim', baslik: 'Sesli Geri Bildirim', degeri: true,
    altAciklama: 'Kart okunduğunda bip sesi çal',
    ayarlar: {}, kontroller: [], hatalar: [], uyarilar: [],
  },
  {
    turu: 'Anahtar', ismi: 'titresimGeriBildirim', baslik: 'Titreşim Geri Bildirimi', degeri: true,
    altAciklama: 'Destekleyen cihazlarda titreşim ile geri bildirim ver',
    ayarlar: {}, kontroller: [], hatalar: [], uyarilar: [],
  },
];

// ═══════════════════════════════════════════════════════════════════════════════
// 4. GÖRÜNÜM & TEMA AYARLARI
// ═══════════════════════════════════════════════════════════════════════════════

export const GORUNUM_PARAMETRELERI: IParametre[] = [
  {
    turu: 'Simgeli Başlık', ismi: '_baslik_tema', baslik: '🎨 Görünüm & Tema',
    degeri: null, ayarlar: {}, kontroller: [], hatalar: [], uyarilar: [],
  },
  {
    turu: 'Anahtar', ismi: 'karanlikMod', baslik: 'Karanlık Mod', degeri: false,
    altAciklama: 'Gece çalışma için koyu tema',
    ayarlar: {}, kontroller: [], hatalar: [], uyarilar: [],
  },
  {
    turu: 'Açılır Kutu', ismi: 'ekranModu', baslik: 'Ekran Modu', degeri: 'pano',
    altAciklama: 'HMI panelin çalışma şekli',
    ayarlar: {
      secenekler: [
        { etiket: '📊 Pano — Tam bilgi paneli', deger: 'pano' },
        { etiket: '🖥️ Kiosk — Sadeleştirilmiş', deger: 'kiosk' },
        { etiket: '📱 Minimal — Sadece kart okuma', deger: 'minimal' },
      ],
    },
    kontroller: [], hatalar: [], uyarilar: [],
  },
  {
    turu: 'Anahtar', ismi: 'tamEkran', baslik: 'Tam Ekran Modu', degeri: false,
    altAciklama: 'Tarayıcıyı tam ekran modunda çalıştır',
    ayarlar: {}, kontroller: [], hatalar: [], uyarilar: [],
  },
  {
    turu: 'Anahtar', ismi: 'ekranAcikTut', baslik: 'Ekranı Açık Tut', degeri: true,
    altAciklama: 'Wake Lock API ile ekranın kapanmasını engelle',
    ayarlar: {}, kontroller: [], hatalar: [], uyarilar: [],
  },
  {
    turu: 'Anahtar', ismi: 'otomatikTema', baslik: 'Otomatik Tema (Işık Sensörü)', degeri: false,
    altAciklama: 'Ortam ışığına göre otomatik karanlık/aydınlık geçişi',
    ayarlar: {}, kontroller: [], hatalar: [], uyarilar: [],
  },
  {
    turu: 'Sayı', ismi: 'slideAraligi', baslik: 'Slayt Değişim Süresi (sn)', degeri: 6,
    altAciklama: 'Bekleme ekranında slaytların otomatik geçiş süresi',
    ayarlar: { min: 3, maks: 30, adim: 1 },
    kontroller: [], hatalar: [], uyarilar: [],
  },
  {
    turu: 'Sayı', ismi: 'reklamAraligi', baslik: 'Duyuru Değişim Süresi (sn)', degeri: 5,
    altAciklama: 'Alt duyuru/reklam bandındaki kaydırma hızı',
    ayarlar: { min: 2, maks: 15, adim: 1 },
    kontroller: [], hatalar: [], uyarilar: [],
  },
];

// ═══════════════════════════════════════════════════════════════════════════════
// 5. PDKS (PERSONEL DEVAM KONTROL SİSTEMİ)
// ═══════════════════════════════════════════════════════════════════════════════

export const PDKS_PARAMETRELERI: IParametre[] = [
  {
    turu: 'Simgeli Başlık', ismi: '_baslik_pdks', baslik: '🕒 PDKS & Giriş-Çıkış',
    degeri: null, ayarlar: {}, kontroller: [], hatalar: [], uyarilar: [],
  },
  {
    turu: 'Anahtar', ismi: 'pdksAktif', baslik: 'PDKS Giriş/Çıkış Kaydı', degeri: true,
    altAciklama: 'Kart okutulduğunda otomatik giriş/çıkış kaydı oluştur',
    ayarlar: {}, kontroller: [], hatalar: [], uyarilar: [],
  },
  {
    turu: 'Açılır Kutu', ismi: 'pdksMod', baslik: 'PDKS Modu', degeri: 'otomatik',
    altAciklama: 'Giriş/çıkış belirleme yöntemi',
    ayarlar: {
      secenekler: [
        { etiket: '🔄 Otomatik (Kart koy=Giriş, Çek=Çıkış)', deger: 'otomatik' },
        { etiket: '⏱️ Zamanlı (İlk=Giriş, Son=Çıkış)', deger: 'zamanli' },
        { etiket: '👆 Manuel (Personel seçer)', deger: 'manuel' },
      ],
    },
    kontroller: [], hatalar: [], uyarilar: [],
  },
  {
    turu: 'Sayı', ismi: 'kartBeklemeSuresi', baslik: 'Kart Bekleme Süresi (sn)', degeri: 15,
    altAciklama: 'Kart okutulduktan sonra personel bilgisinin ekranda kalma süresi',
    ayarlar: { min: 3, maks: 60, adim: 1 },
    kontroller: [], hatalar: [], uyarilar: [],
  },
  {
    turu: 'Anahtar', ismi: 'bilinmeyenKartUyari', baslik: 'Bilinmeyen Kart Uyarısı', degeri: true,
    altAciklama: 'Tanınmayan kart okutulduğunda sesli/görsel uyarı ver',
    ayarlar: {}, kontroller: [], hatalar: [], uyarilar: [],
  },
  {
    turu: 'Anahtar', ismi: 'fotografCek', baslik: 'Giriş/Çıkışta Fotoğraf Çek', degeri: false,
    altAciklama: 'Kamera varsa giriş/çıkışta otomatik fotoğraf çek',
    ayarlar: {}, kontroller: [], hatalar: [], uyarilar: [],
  },
];

// ═══════════════════════════════════════════════════════════════════════════════
// 6. BİLDİRİM & OLAY AYARLARI
// ═══════════════════════════════════════════════════════════════════════════════

export const BILDIRIM_PARAMETRELERI: IParametre[] = [
  {
    turu: 'Simgeli Başlık', ismi: '_baslik_bildirim', baslik: '🔔 Bildirim & Olaylar',
    degeri: null, ayarlar: {}, kontroller: [], hatalar: [], uyarilar: [],
  },
  {
    turu: 'Anahtar', ismi: 'olayLoglama', baslik: 'Olay Loglama', degeri: true,
    altAciklama: 'Tüm cihaz olaylarını sunucuya kaydet (kart okuma, hata, durum değişikliği)',
    ayarlar: {}, kontroller: [], hatalar: [], uyarilar: [],
  },
  {
    turu: 'Anahtar', ismi: 'sesliUyari', baslik: 'Sesli Uyarılar', degeri: true,
    altAciklama: 'Hata ve uyarılarda ses çal',
    ayarlar: {}, kontroller: [], hatalar: [], uyarilar: [],
  },
  {
    turu: 'Anahtar', ismi: 'uzakKomutKabul', baslik: 'Uzak Komutları Kabul Et', degeri: true,
    altAciklama: 'Admin panelinden gönderilen komutları çalıştır (yeniden başlat, ekran mesajı, vb.)',
    ayarlar: {}, kontroller: [], hatalar: [], uyarilar: [],
  },
  {
    turu: 'Anahtar', ismi: 'hataBildirimi', baslik: 'Hata Bildirimi', degeri: true,
    altAciklama: 'JavaScript hataları ve ağ kesintilerini sunucuya bildir',
    ayarlar: {}, kontroller: [], hatalar: [], uyarilar: [],
  },
  {
    turu: 'Sayı', ismi: 'maksOlayLog', baslik: 'Maks. Olay Log Sayısı', degeri: 100,
    altAciklama: 'Bellekte tutulacak maksimum olay sayısı',
    ayarlar: { min: 10, maks: 1000, adim: 10 },
    kontroller: [], hatalar: [], uyarilar: [],
  },
];

// ═══════════════════════════════════════════════════════════════════════════════
// 7. GÜVENLİK AYARLARI
// ═══════════════════════════════════════════════════════════════════════════════

export const GUVENLIK_PARAMETRELERI: IParametre[] = [
  {
    turu: 'Simgeli Başlık', ismi: '_baslik_guvenlik', baslik: '🛡️ Güvenlik',
    degeri: null, ayarlar: {}, kontroller: [], hatalar: [], uyarilar: [],
  },
  {
    turu: 'Parola', ismi: 'ayarParolasi', baslik: 'Ayarlar Parolası', degeri: null,
    yerTutucu: 'Ayarlar sayfasına erişim parolası',
    altAciklama: 'Boş bırakılırsa parola koruması olmaz',
    ayarlar: { solSimge: 'lock' },
    kontroller: [], hatalar: [], uyarilar: [],
  },
  {
    turu: 'Anahtar', ismi: 'ekranKilidi', baslik: 'Ekran Kilidi', degeri: false,
    altAciklama: 'Belirli süre hareketsizlikten sonra ekranı kilitle',
    ayarlar: {}, kontroller: [], hatalar: [], uyarilar: [],
  },
  {
    turu: 'Sayı', ismi: 'ekranKilidiSuresi', baslik: 'Ekran Kilidi Süresi (dk)', degeri: 30,
    altAciklama: 'Hareketsizlik sonrası ekran kilitlenme süresi',
    ayarlar: { min: 1, maks: 120, adim: 1 },
    kontroller: [], hatalar: [], uyarilar: [],
  },
  {
    turu: 'Anahtar', ismi: 'sagTikEngelle', baslik: 'Sağ Tık Engelle', degeri: true,
    altAciklama: 'Kullanıcıların sağ tık menüsüne erişimini engelle',
    ayarlar: {}, kontroller: [], hatalar: [], uyarilar: [],
  },
  {
    turu: 'Anahtar', ismi: 'devToolsEngelle', baslik: 'Geliştirici Araçlarını Engelle', degeri: true,
    altAciklama: 'F12 ve Ctrl+Shift+I kısayollarını devre dışı bırak',
    ayarlar: {}, kontroller: [], hatalar: [], uyarilar: [],
  },
];

// ═══════════════════════════════════════════════════════════════════════════════
// YARDIMCI: TÜM SEKMELERİ BİRLEŞTİR
// ═══════════════════════════════════════════════════════════════════════════════

export interface IHmiAyarSekmesi {
  ismi: string;
  simge: string;
  aciklama: string;
  parametreler: IParametre[];
}

export const HMI_AYAR_SEKMELERI: IHmiAyarSekmesi[] = [
  { ismi: 'Cihaz', simge: 'desktop', aciklama: 'Cihaz kimlik ve konum ayarları', parametreler: CIHAZ_KIMLIK_PARAMETRELERI },
  { ismi: 'Bağlantı', simge: 'global', aciklama: 'Sunucu ve ağ bağlantı ayarları', parametreler: BAGLANTI_PARAMETRELERI },
  { ismi: 'Kart Okuyucu', simge: 'credit-card', aciklama: 'RFID/NFC kart okuyucu ayarları', parametreler: KART_OKUYUCU_PARAMETRELERI },
  { ismi: 'Görünüm', simge: 'bg-colors', aciklama: 'Tema ve ekran ayarları', parametreler: GORUNUM_PARAMETRELERI },
  { ismi: 'PDKS', simge: 'clock-circle', aciklama: 'Personel devam kontrol ayarları', parametreler: PDKS_PARAMETRELERI },
  { ismi: 'Bildirimler', simge: 'bell', aciklama: 'Olay loglama ve bildirim ayarları', parametreler: BILDIRIM_PARAMETRELERI },
  { ismi: 'Güvenlik', simge: 'safety-certificate', aciklama: 'Güvenlik ve erişim ayarları', parametreler: GUVENLIK_PARAMETRELERI },
];

// ═══════════════════════════════════════════════════════════════════════════════
// YARDIMCI: PARAMETRE -> localStorage SENKRONLAYICI
// ═══════════════════════════════════════════════════════════════════════════════

const HMI_AYARLAR_STORAGE_KEY = 'hmi-pano-ayarlar';

/** Tüm HMI ayarlarını localStorage'dan yükle ve parametrelere uygula */
export function hmiAyarlariYukle(sekmeler: IHmiAyarSekmesi[]): void {
  try {
    const raw = localStorage.getItem(HMI_AYARLAR_STORAGE_KEY);
    if (!raw) return;
    const kayitli = JSON.parse(raw);
    for (const sekme of sekmeler) {
      for (const p of sekme.parametreler) {
        if (p.ismi.startsWith('_')) continue; // Simgeli başlıkları atla
        if (kayitli[p.ismi] !== undefined) {
          p.degeri = kayitli[p.ismi];
        }
      }
    }
  } catch {}
}

/** Tüm HMI parametrelerini localStorage'a kaydet */
export function hmiAyarlariKaydet(sekmeler: IHmiAyarSekmesi[]): void {
  const veri: Record<string, any> = {};
  for (const sekme of sekmeler) {
    for (const p of sekme.parametreler) {
      if (p.ismi.startsWith('_')) continue;
      veri[p.ismi] = p.degeri;
    }
  }
  localStorage.setItem(HMI_AYARLAR_STORAGE_KEY, JSON.stringify(veri));

  // Eski localStorage key'leriyle geriye dönük uyumluluk
  if (veri.cihazKimlik) localStorage.setItem('fikoyt_cihaz_kimlik', veri.cihazKimlik);
  if (veri.cihazIsmi) localStorage.setItem('fikoyt_cihaz_ismi', veri.cihazIsmi);
  if (veri.karanlikMod !== undefined) localStorage.setItem('hmi-karanlik-mod', veri.karanlikMod ? '1' : '0');
}

/** Tek bir parametrenin değerini al */
export function hmiAyarGetir<T = any>(ismi: string, varsayilan?: T): T {
  try {
    const raw = localStorage.getItem(HMI_AYARLAR_STORAGE_KEY);
    if (!raw) return varsayilan as T;
    const kayitli = JSON.parse(raw);
    return kayitli[ismi] !== undefined ? kayitli[ismi] : (varsayilan as T);
  } catch {
    return varsayilan as T;
  }
}
